(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gymgrl-editorial-carousel"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('[id^="gcc-track-"]').forEach(function(track){
    var id=track.id.replace('gcc-track-','');
    var prev=document.getElementById('gcc-prev-'+id);
    var next=document.getElementById('gcc-next-'+id);
    function getCardW(){var c=track.querySelector('.gcc__card');return c?c.offsetWidth+24:404;}
    if(prev)prev.addEventListener('click',function(){track.scrollBy({left:-getCardW(),behavior:'smooth'});});
    if(next)next.addEventListener('click',function(){track.scrollBy({left:getCardW(),behavior:'smooth'});});
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gymgrl-home-product"] && !Shopify.designMode) return;
  try {
    
(function() {
  var targets = document.querySelectorAll('.ghpd__title, .ghpl__title, .ghqt__text, .gug__title, .ghct__title');
  if (!targets.length) return;
  targets.forEach(function(el) { el.classList.add('headline-anim'); });
  if (!('IntersectionObserver' in window)) {
    targets.forEach(function(el) { el.classList.add('headline-anim--in'); });
    return;
  }
  var io = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('headline-anim--in');
        io.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15 });
  targets.forEach(function(el) { io.observe(el); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gymgrl-product-hero"] && !Shopify.designMode) return;
  try {
    
(function(){
  var mainImg=document.getElementById('gp-main-img');
  var thumbBtns=Array.from(document.querySelectorAll('.gp__thumb-btn'));
  thumbBtns.forEach(function(btn){var pi=new Image();pi.src=btn.dataset.src;});
  var dots=Array.from(document.querySelectorAll('.gp__dot'));
  function goToSlide(idx){
    if(!thumbBtns.length)return;
    var i=(idx+thumbBtns.length)%thumbBtns.length;
    var btn=thumbBtns[i];
    if(mainImg){mainImg.classList.add('gp--fade');var s=btn.dataset.src;setTimeout(function(){mainImg.src=s;mainImg.classList.remove('gp--fade');},150);}
    thumbBtns.forEach(function(t){t.classList.remove('gp__thumb-btn--on');});
    btn.classList.add('gp__thumb-btn--on');
    btn.scrollIntoView({behavior:'smooth',block:'nearest',inline:'nearest'});
    dots.forEach(function(d,n){d.classList.toggle('gp__dot--on',n===i);});
  }
  thumbBtns.forEach(function(btn,idx){btn.addEventListener('click',function(){goToSlide(idx);});});
  dots.forEach(function(d,i){d.addEventListener('click',function(){goToSlide(i);});});
  function activeIdx(){return thumbBtns.findIndex(function(t){return t.classList.contains('gp__thumb-btn--on');});}
  var prevBtn=document.querySelector('.gp__nav--prev');
  var nextBtn=document.querySelector('.gp__nav--next');
  if(prevBtn)prevBtn.addEventListener('click',function(){goToSlide(activeIdx()-1);});
  if(nextBtn)nextBtn.addEventListener('click',function(){goToSlide(activeIdx()+1);});
  var imgWrap=document.querySelector('.gp__img-wrap');
  if(imgWrap&&thumbBtns.length>1){var isx=0;imgWrap.addEventListener('touchstart',function(e){isx=e.touches[0].clientX;},{passive:true});imgWrap.addEventListener('touchend',function(e){var dx=e.changedTouches[0].clientX-isx;if(Math.abs(dx)<50)return;dx<0?goToSlide(activeIdx()+1):goToSlide(activeIdx()-1);},{passive:true});}

  var qtyInput=document.getElementById('gp-qty');
  if(qtyInput){
    document.querySelectorAll('.gp__qty-btn').forEach(function(btn){
      btn.addEventListener('click',function(){
        var val=parseInt(qtyInput.value,10)||1;
        var dir=parseInt(btn.dataset.dir,10);
        var next=val+dir;
        if(next>=parseInt(qtyInput.min,10)&&next<=parseInt(qtyInput.max,10))qtyInput.value=next;
      });
    });
  }

  var radios=document.querySelectorAll('.gp__ptab-radio');
  var perks=document.getElementById('gp-sub-perks');
  var freqSel=document.getElementById('gp-freq');
  radios.forEach(function(r){
    r.addEventListener('change',function(){
      if(!perks)return;
      var isSub=r.value==='sub'&&r.checked;
      if(isSub){
        perks.classList.add('gp--visible');
        if(freqSel)freqSel.name='selling_plan';
      } else {
        perks.classList.remove('gp--visible');
        if(freqSel)freqSel.name='selling_plan_disabled';
      }
    });
  });
  if(perks)perks.classList.add('gp--visible');

  var atcBtn=document.getElementById('gp-atc');
  var sticky=document.getElementById('gp-sticky');
  var stickyBtn=document.getElementById('gp-sticky-btn');
  if(atcBtn&&sticky&&('IntersectionObserver' in window)){
    var obs=new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if(e.isIntersecting){
          sticky.classList.remove('gp--show');
          sticky.setAttribute('aria-hidden','true');
        } else {
          sticky.classList.add('gp--show');
          sticky.setAttribute('aria-hidden','false');
        }
      });
    },{threshold:0});
    obs.observe(atcBtn);
  }
  if(stickyBtn&&atcBtn){
    stickyBtn.addEventListener('click',function(){atcBtn.click();});
  }

  var rcTrack=document.querySelector('.gp__rc-track');
  var rcDots=rcTrack?Array.from(rcTrack.closest('.gp__social-proof').querySelectorAll('.gp__rc-dot')):[];
  var rcCards=rcTrack?Array.from(rcTrack.querySelectorAll('.gp__rc-card')):[];
  var rcIdx=0;
  var rcTimer=null;
  function goToReview(i){
    rcIdx=(i+rcCards.length)%rcCards.length;
    if(rcTrack)rcTrack.style.transform='translateX(-'+rcIdx*100+'%)';
    rcCards.forEach(function(c,n){c.classList.toggle('gp__rc-card--on',n===rcIdx);});
    rcDots.forEach(function(d,n){d.classList.toggle('gp__rc-dot--on',n===rcIdx);});
  }
  function startTimer(){
    clearInterval(rcTimer);
    rcTimer=setInterval(function(){goToReview(rcIdx+1);},9000);
  }
  rcDots.forEach(function(d){d.addEventListener('click',function(){goToReview(parseInt(d.dataset.rcIdx,10));startTimer();});});
  if(rcCards.length>1){
    startTimer();
    if(rcTrack){
      rcTrack.addEventListener('mouseenter',function(){clearInterval(rcTimer);});
      rcTrack.addEventListener('mouseleave',function(){startTimer();});
    }
  }
  var rcWrap=document.querySelector('.gp__rc-track-wrap');
  if(rcWrap&&rcCards.length>1){var rsx=0;rcWrap.addEventListener('touchstart',function(e){rsx=e.touches[0].clientX;},{passive:true});rcWrap.addEventListener('touchend',function(e){var dx=e.changedTouches[0].clientX-rsx;if(Math.abs(dx)<50)return;dx<0?goToReview(rcIdx+1):goToReview(rcIdx-1);startTimer();},{passive:true});}
})();
(function(){
  var targets=document.querySelectorAll('.gcc__title,.gbi__title,.gst__title,.ghtu__title,.grt__title,.gis__title,.gpq__quote,.gtm__title');
  if(!targets.length)return;
  targets.forEach(function(el){el.classList.add('headline-anim');});
  if(!('IntersectionObserver' in window)){targets.forEach(function(el){el.classList.add('headline-anim--in');});return;}
  var io=new IntersectionObserver(function(entries){entries.forEach(function(entry){if(entry.isIntersecting){entry.target.classList.add('headline-anim--in');io.unobserve(entry.target);}});},{threshold:0.15});
  targets.forEach(function(el){io.observe(el);});
})();
(function(){
  var subRadios=Array.from(document.querySelectorAll('.gp__bundle-radio'));
  var otRadios=Array.from(document.querySelectorAll('.gp__bundle-radio-ot'));
  var subPanel=document.querySelector('.gp__bundle-options--sub');
  var otPanel=document.querySelector('.gp__bundle-options--ot');
  var tabBtns=Array.from(document.querySelectorAll('.gp__btab'));
  var qtyInput=document.getElementById('gp-qty');
  var activeTab='sub';
  if(!subRadios.length&&!otRadios.length)return;
  var stickyEyebrow=document.querySelector('.gp-sticky__eyebrow');
  var stickyName=document.querySelector('.gp-sticky__name');
  var stickyFooter=document.querySelector('.gp-sticky__footer');
  var stickyPrice=document.querySelector('.gp-sticky__price');
  var bundleFreqSel=document.getElementById('gp-bundle-freq-sel');
  function formatMoney(pence){return '\u00a3'+(pence/100).toFixed(2);}
  function activeRadios(){return activeTab==='sub'?subRadios:otRadios;}
  function updateSticky(){
    var activeBtn=tabBtns.find(function(b){return b.classList.contains('gp__btab--active');});
    var tabText=activeBtn?activeBtn.querySelector('.gp__btab-main').textContent.trim():'';
    var checkedRadio=activeRadios().find(function(r){return r.checked;});
    var bundleLabel='';
    var bundleRaw=0;
    if(checkedRadio){
      var card=checkedRadio.closest('.gp__bundle-card');
      if(card){
        var labelEl=card.querySelector('.gp__bundle-label');
        if(labelEl)bundleLabel=labelEl.textContent.trim();
        bundleRaw=parseInt(card.dataset.priceRaw||0,10);
      }
    }
    if(stickyEyebrow)stickyEyebrow.textContent=tabText;
    if(stickyName)stickyName.textContent=bundleLabel;
    if(stickyPrice&&bundleRaw>0){stickyPrice.textContent=formatMoney(bundleRaw);}
  }
  function syncSellingPlan(){
    if(!bundleFreqSel)return;
    if(activeTab==='sub'){
      var checkedRadio=subRadios.find(function(r){return r.checked;});
      var planId='';
      if(checkedRadio){
        var card=checkedRadio.closest('.gp__bundle-card');
        if(card)planId=card.dataset.sellingPlan||'';
      }
      bundleFreqSel.name='selling_plan';
      bundleFreqSel.value=planId;
    } else {
      bundleFreqSel.name='selling_plan_disabled';
      bundleFreqSel.value='';
    }
  }
  function selectBundle(r,radioSet){
    radioSet.forEach(function(x){
      var card=x.closest('.gp__bundle-card');
      if(card)card.classList.remove('gp__bundle-card--active');
    });
    var card=r.closest('.gp__bundle-card');
    if(card)card.classList.add('gp__bundle-card--active');
    if(qtyInput){qtyInput.value=r.dataset.qty||1;}
    syncSellingPlan();
    updateSticky();
  }
  function switchTab(){
    var isSub=activeTab==='sub';
    if(subPanel)subPanel.style.display=isSub?'':'none';
    if(otPanel)otPanel.style.display=isSub?'none':'';
    var currentRadios=activeRadios();
    var checked=currentRadios.find(function(r){return r.checked;});
    if(checked)selectBundle(checked,currentRadios);
    else if(currentRadios[0]){currentRadios[0].checked=true;selectBundle(currentRadios[0],currentRadios);}
    syncSellingPlan();
    updateSticky();
  }
  tabBtns.forEach(function(btn){
    btn.addEventListener('click',function(){
      activeTab=btn.dataset.tab;
      tabBtns.forEach(function(b){
        b.classList.toggle('gp__btab--active',b===btn);
        b.setAttribute('aria-selected',b===btn?'true':'false');
      });
      switchTab();
    });
  });
  subRadios.forEach(function(r){r.addEventListener('change',function(){selectBundle(r,subRadios);});});
  otRadios.forEach(function(r){r.addEventListener('change',function(){selectBundle(r,otRadios);});});
  var gpForm=document.getElementById('gp-form');
  if(gpForm){
    gpForm.addEventListener('submit',function(e){
      e.preventDefault();
      var btn=document.getElementById('gp-atc');
      var origText=btn?btn.textContent.trim():'';
      if(btn){btn.disabled=true;btn.textContent='Adding\u2026';}
      var currentRadios=activeRadios();
      var checked=currentRadios.find(function(r){return r.checked;});
      if(!checked){if(btn){btn.disabled=false;btn.textContent=origText;}return;}
      var card=checked.closest('.gp__bundle-card');
      if(!card){
        // No bundle card — this is the subscribe & save / one-time tab (non-bundle layout).
        // Add via fetch so the cart drawer opens instead of redirecting to the cart page.
        var vidInput=document.getElementById('gp-vid')||gpForm.querySelector('[name="id"]');
        var vid=vidInput?parseInt(vidInput.value,10):0;
        var planInput=gpForm.querySelector('[name="selling_plan"]');
        var planVal=planInput?planInput.value:'';
        if(!vid){if(btn){btn.disabled=false;btn.textContent=origText;}gpForm.submit();return;}
        var cartSectionIds=Array.from(document.querySelectorAll('cart-items-component')).map(function(el){return el.dataset.sectionId;}).filter(Boolean);
        var addItem={id:vid,quantity:1};
        if(planVal)addItem.selling_plan=parseInt(planVal,10);
        var postBody={items:[addItem]};
        if(cartSectionIds.length)postBody.sections=cartSectionIds.join(',');
        fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(postBody)})
          .then(function(r){return r.ok?r.json():r.json().then(function(d){throw new Error(d.description||'Could not add to cart');});})
          .then(function(cartData){
            if(btn){btn.disabled=false;btn.textContent=origText;}
            var cartDrawer=document.querySelector('cart-drawer-component');
            function dispatchAndOpen(sections){
              var itemCount=null;
              Object.keys(sections||{}).forEach(function(id){
                var h=sections[id]||'';var d=new DOMParser().parseFromString(h,'text/html');var el=d.querySelector('[ref="cartItemCount"]');if(el){var n=parseInt(el.textContent,10);if(!isNaN(n))itemCount=n;}
              });
              document.dispatchEvent(new CustomEvent('cart:update',{bubbles:true,detail:{resource:cartData,data:{sections:sections||{},itemCount:itemCount||0}}}));
              if(typeof window.updateHeaderCartIcon==='function'&&itemCount!==null)window.updateHeaderCartIcon(itemCount);
              if(cartDrawer&&typeof cartDrawer.open==='function')cartDrawer.open();
            }
            if(cartData.sections&&Object.keys(cartData.sections).length){dispatchAndOpen(cartData.sections);}
            else if(cartSectionIds.length){fetch('/?sections='+cartSectionIds.join(','),{credentials:'same-origin'}).then(function(r){return r.json();}).then(dispatchAndOpen).catch(function(){dispatchAndOpen({});});}
            else{dispatchAndOpen({});}
          })
          .catch(function(err){if(btn){btn.disabled=false;btn.textContent=origText;}if(err&&err.message)alert(err.message);});
        return;
      }
      var planId=card.dataset.sellingPlan||'';
      var variantIds=(card.dataset.variants||'').split(',').filter(Boolean).map(Number).filter(Boolean);
      if(!variantIds.length){if(btn){btn.disabled=false;btn.textContent=origText;}gpForm.submit();return;}
      var bundleId=Date.now().toString(36)+Math.random().toString(36).slice(2);
      var bundleSize=variantIds.length;
      var items=variantIds.map(function(vid,i){
        var props={'_bundle_id':bundleId};
        if(planId&&bundleSize>1){
          props['_bundle_type']='subscription_bundle';
          props['_bundle_required_count']=String(bundleSize);
          props['_bundle_selling_plan_id']=planId;
        }
        var item={id:vid,quantity:1,properties:props};
        if(planId)item.selling_plan=parseInt(planId,10);
        return item;
      });
      var cartSectionIds=Array.from(document.querySelectorAll('cart-items-component')).map(function(el){return el.dataset.sectionId;}).filter(Boolean);
      var postBody={items:items};
      if(cartSectionIds.length)postBody.sections=cartSectionIds.join(',');
      fetch('/cart/add.js',{
        method:'POST',
        headers:{'Content-Type':'application/json','Accept':'application/json'},
        body:JSON.stringify(postBody)
      })
      .then(function(r){
        if(!r.ok)return r.json().then(function(d){throw new Error(d.description||'Could not add to cart');});
        return r.json();
      })
      .then(function(cartData){
        if(btn){btn.disabled=false;btn.textContent=origText;}
        var discountCode=activeTab==='ot'?(card.dataset.discountCode||''):'';
        function openDrawer(){
          var cartDrawer=document.querySelector('cart-drawer-component');
          if(typeof window.__gpCartToken==='undefined')window.__gpCartToken=0;
          var token=++window.__gpCartToken;
          console.warn('[CartDrawer] add-to-cart success');
          function getCountFromSections(secs){
            var ids=Object.keys(secs||{});
            for(var i=0;i<ids.length;i++){
              var h=secs[ids[i]];if(!h)continue;
              var d=new DOMParser().parseFromString(h,'text/html');
              var el=d.querySelector('[ref="cartItemCount"]');
              if(el){var n=parseInt(el.textContent,10);return isNaN(n)?null:n;}
            }
            return null;
          }
          function visibleDrawerHasItems(){
            var dr=document.querySelector('cart-drawer-component');
            return dr?Boolean(dr.querySelector('.cart-items__table-row,.cart-item,[data-cart-item]')):false;
          }
          function renderDrawerDirectly(secs){
            var ids=Object.keys(secs||{});
            var sHtml='';
            for(var i=0;i<ids.length;i++){
              var h=secs[ids[i]]||'';
              if(h&&(h.includes('cart-item')||h.includes('cart-items-component'))){sHtml=h;break;}
            }
            if(!sHtml&&ids.length)sHtml=secs[ids[0]]||'';
            if(!sHtml)return false;
            var fdoc=new DOMParser().parseFromString(sHtml,'text/html');
            var freshCI=fdoc.querySelector('cart-items-component');
            var currCI=document.querySelector('cart-drawer-component cart-items-component');
            if(!freshCI||!currCI){
              console.error('[CartDrawer] direct render: cart-items-component not found',{fresh:!!freshCI,current:!!currCI});
              return false;
            }
            // Replace the whole element so connectedCallback fires on the fresh element.
            // innerHTML-only would reuse the existing element whose refs may be stale.
            currCI.replaceWith(freshCI);
            var dlg=document.querySelector('cart-drawer-component dialog');
            if(dlg)dlg.classList.remove('cart-drawer--empty');
            // freshCI is now live in the DOM; its connectedCallback has run and refs are set.
            var rows=freshCI.querySelectorAll('.cart-items__table-row,.cart-item').length;
            console.warn('[CartDrawer] direct render done, rows:',rows,freshCI.textContent.trim().slice(0,200));
            return rows>0;
          }
          function dispatchAndOpen(sections){
            if(token!==window.__gpCartToken){
              console.warn('[CartDrawer] stale refresh ignored',{token:token,latest:window.__gpCartToken});
              return;
            }
            var keys=Object.keys(sections||{});
            console.warn('[CartDrawer] sections keys',keys);
            keys.forEach(function(id){
              var html=sections[id]||'';
              console.warn('[CartDrawer] section',id,{len:html.length,hasCartItem:html.includes('cart-item'),hasEmpty:/empty|your cart is empty/i.test(html),preview:html.slice(0,300)});
            });
            console.warn('[CartDrawer] drawer before render',Array.from(document.querySelectorAll('cart-drawer-component,cart-items-component')).map(function(el){return{tag:el.tagName,sectionId:(el.dataset||{}).sectionId,hasItems:el.innerHTML.includes('cart-item'),txt:el.textContent.trim().slice(0,120)};}));
            // Inject section CSS before morph. cart-products.liquid {% stylesheet %} is only
            // processed by Shopify when the snippet renders (cart non-empty). On a page that
            // loaded with an empty cart its style[data-section-stylesheet] is absent from <head>.
            // The sections API response includes it in the parsed document's <head>; extract and
            // insert it into the live section wrapper so the CSS applies before morph paints.
            keys.forEach(function(id){
              var html=sections[id];if(!html)return;
              var frag=new DOMParser().parseFromString(html,'text/html');
              var newStyle=frag.querySelector('style[data-section-stylesheet]');
              if(!newStyle)return;
              var sectionEl=document.getElementById('shopify-section-'+id);
              if(!sectionEl){console.warn('[CartDrawer] section el not found for stylesheet inject:',id);return;}
              var existing=sectionEl.querySelector('style[data-section-stylesheet]');
              if(existing){existing.textContent=newStyle.textContent;console.warn('[CartDrawer] stylesheet updated for',id);}
              else{sectionEl.insertBefore(newStyle.cloneNode(true),sectionEl.firstChild);console.warn('[CartDrawer] stylesheet injected for',id);}
            });
            var itemCount=getCountFromSections(sections);
            document.dispatchEvent(new CustomEvent('cart:update',{
              bubbles:true,
              detail:{resource:cartData,data:{sections:sections,itemCount:itemCount||0}}
            }));
            // morph() in morphSection is synchronous, so the DOM is updated before dispatchEvent
            // returns. Check now and use direct replace only if morph did not populate items.
            console.warn('[CartDrawer] drawer after cart:update',Array.from(document.querySelectorAll('cart-drawer-component,cart-items-component')).map(function(el){return{tag:el.tagName,sectionId:(el.dataset||{}).sectionId,hasItems:el.innerHTML.includes('cart-item'),txt:el.textContent.trim().slice(0,120)};}));
            if(!visibleDrawerHasItems()&&keys.length>0){
              console.warn('[CartDrawer] morph did not populate drawer — using direct fallback');
              renderDrawerDirectly(sections);
            }
            // Force ref update on the final cart-items-component (whether morphed in-place or
            // freshly replaced by renderDrawerDirectly). MutationObserver is set up in
            // requestIdleCallback so may not be live yet; updatedCallback() calls #updateRefs()
            // directly, bypassing the timing gap.
            document.querySelectorAll('cart-items-component').forEach(function(el){
              if(typeof el.updatedCallback==='function')el.updatedCallback();
            });
            if(typeof window.updateHeaderCartIcon==='function'&&itemCount!==null){
              window.updateHeaderCartIcon(itemCount);
            }
            if(typeof window.hydrateHeaderCartFromCartJs==='function'){
              window.hydrateHeaderCartFromCartJs();
            }
            console.warn('[HeaderCart] hydrated from cart.js');
            console.warn('[CartDrawer] opening drawer');
            if(cartDrawer&&typeof cartDrawer.open==='function')cartDrawer.open();
          }
          if(cartData.sections&&Object.keys(cartData.sections).length){
            console.warn('[CartDrawer] using sections from cart/add.js response');
            dispatchAndOpen(cartData.sections);
          } else if(cartSectionIds.length){
            var root=(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/';
            console.warn('[CartDrawer] fetching fresh drawer sections');
            fetch(root+'?sections='+cartSectionIds.join(','),{credentials:'same-origin'})
              .then(function(r){return r.json();})
              .then(function(sections){
                console.warn('[CartDrawer] fresh drawer sections fetched');
                dispatchAndOpen(sections);
              })
              .catch(function(){dispatchAndOpen({});});
          } else {
            dispatchAndOpen({});
          }
        }
        if(discountCode){
          fetch('/discount/'+encodeURIComponent(discountCode),{method:'GET',credentials:'same-origin'})
            .then(openDrawer).catch(openDrawer);
        } else {
          openDrawer();
        }
      })
      .catch(function(err){
        if(btn){btn.disabled=false;btn.textContent=origText;}
        if(err&&err.message)alert(err.message);
      });
    });
  }
  // Default to one-time tab on page load
  if(otRadios.length){
    activeTab='ot';
    tabBtns.forEach(function(b){
      var isOt=b.dataset.tab==='ot';
      b.classList.toggle('gp__btab--active',isOt);
      b.setAttribute('aria-selected',isOt?'true':'false');
    });
    if(!otRadios.some(function(r){return r.checked;})){
      otRadios[0].checked=true;
    }
  }
  switchTab();
})();
// Removed: legacy bundle cleanup IIFE deleted normal non-bundle cart items.
// Sibling removal is handled exclusively by assets/bundle-guard.js.
(function(){
  // Simple Buy Box (One-time / Subscribe & Save) — fully independent of the
  // bundle selector above. No-ops entirely when the simple selector is
  // switched off in section settings (no .gp__simple-radio elements render).
  var simpleRadios=Array.from(document.querySelectorAll('.gp__simple-radio'));
  if(!simpleRadios.length)return;
  var gpForm=document.getElementById('gp-form');
  if(!gpForm)return;

  // Keep the sticky purchase bar in sync with whichever option is selected:
  // product name as the main title, the selected option as clear subtext
  // below it (so neither gets cut off on mobile / a narrow desktop window),
  // and only the actual charged price (not the crossed-out compare price).
  var simpleSelector=document.getElementById('gp-simple-selector');
  var productTitle=simpleSelector?simpleSelector.dataset.productTitle||'':'';
  var stickyName=document.querySelector('.gp-sticky__name');
  var stickyFooter=document.querySelector('.gp-sticky__footer');
  var stickyPrice=document.querySelector('.gp-sticky__price');
  function updateSimpleSticky(){
    var checked=simpleRadios.find(function(r){return r.checked;});
    if(!checked)return;
    var tab=checked.closest('.gp__ptab');
    var titleEl=tab?tab.querySelector('.gp__ptab-title'):null;
    var priceEl=tab?tab.querySelector('.gp__ptab-price strong'):null;
    var optionLabel='';
    if(titleEl){
      var titleClone=titleEl.cloneNode(true);
      var badgeEl=titleClone.querySelector('.gp__ptab-badge');
      if(badgeEl)badgeEl.remove();
      optionLabel=titleClone.textContent.trim();
    }
    var priceText=priceEl?priceEl.textContent.trim():'';
    if(stickyName&&productTitle)stickyName.textContent=productTitle;
    if(stickyFooter)stickyFooter.textContent=optionLabel;
    if(stickyPrice&&priceText)stickyPrice.textContent=priceText;
  }
  simpleRadios.forEach(function(r){r.addEventListener('change',updateSimpleSticky);});
  updateSimpleSticky();

  gpForm.addEventListener('submit',function(e){
    var checked=simpleRadios.find(function(r){return r.checked;});
    if(!checked)return;
    e.preventDefault();
    var btn=document.getElementById('gp-atc');
    var origText=btn?btn.textContent.trim():'';
    if(btn){btn.disabled=true;btn.textContent='Adding…';}
    var vidInput=document.getElementById('gp-simple-vid');
    var vid=vidInput?parseInt(vidInput.value,10):0;
    var planVal=checked.value==='sub'?checked.dataset.sellingPlan:'';
    if(!vid){if(btn){btn.disabled=false;btn.textContent=origText;}return;}
    var qtyInput=document.getElementById('gp-qty');
    var qty=qtyInput?(parseInt(qtyInput.value,10)||1):1;
    var cartSectionIds=Array.from(document.querySelectorAll('cart-items-component')).map(function(el){return el.dataset.sectionId;}).filter(Boolean);
    var addItem={id:vid,quantity:qty};
    if(planVal)addItem.selling_plan=parseInt(planVal,10);
    var postBody={items:[addItem]};
    if(cartSectionIds.length)postBody.sections=cartSectionIds.join(',');
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(postBody)})
      .then(function(r){return r.ok?r.json():r.json().then(function(d){throw new Error(d.description||'Could not add to cart');});})
      .then(function(cartData){
        if(btn){btn.disabled=false;btn.textContent=origText;}
        var cartDrawer=document.querySelector('cart-drawer-component');
        function dispatchAndOpen(sections){
          var itemCount=null;
          Object.keys(sections||{}).forEach(function(id){
            var h=sections[id]||'';var d=new DOMParser().parseFromString(h,'text/html');var el=d.querySelector('[ref="cartItemCount"]');if(el){var n=parseInt(el.textContent,10);if(!isNaN(n))itemCount=n;}
          });
          document.dispatchEvent(new CustomEvent('cart:update',{bubbles:true,detail:{resource:cartData,data:{sections:sections||{},itemCount:itemCount||0}}}));
          if(typeof window.updateHeaderCartIcon==='function'&&itemCount!==null)window.updateHeaderCartIcon(itemCount);
          if(cartDrawer&&typeof cartDrawer.open==='function')cartDrawer.open();
        }
        if(cartData.sections&&Object.keys(cartData.sections).length){dispatchAndOpen(cartData.sections);}
        else if(cartSectionIds.length){fetch('/?sections='+cartSectionIds.join(','),{credentials:'same-origin'}).then(function(r){return r.json();}).then(dispatchAndOpen).catch(function(){dispatchAndOpen({});});}
        else{dispatchAndOpen({});}
      })
      .catch(function(err){if(btn){btn.disabled=false;btn.textContent=origText;}if(err&&err.message)alert(err.message);});
  });
})();
(function(){
  var vidsGrid=document.querySelector('.gp__vids');
  if(!vidsGrid)return;
  var items=Array.from(vidsGrid.querySelectorAll('.gp__vid-item'));
  var endTimers=new Map();

  function resetToCover(item){
    var video=item.querySelector('.gp__vid');
    if(!video)return;
    clearTimeout(endTimers.get(item));
    endTimers.delete(item);
    video.pause();
    video.currentTime=0;
    video.muted=true;
    item.classList.remove('gp__vid-item--playing');
  }

  function playVideo(item){
    var video=item.querySelector('.gp__vid');
    if(!video)return;
    items.forEach(function(other){if(other!==item)resetToCover(other);});
    clearTimeout(endTimers.get(item));
    video.currentTime=0;
    video.muted=false;
    item.classList.add('gp__vid-item--playing');
    video.play().catch(function(){resetToCover(item);});
  }

  items.forEach(function(item){
    var video=item.querySelector('.gp__vid');
    if(!video)return;
    video.muted=true;
    var playBtn=item.querySelector('.gp__vid-play');
    var cover=item.querySelector('.gp__vid-cover');
    function handleActivate(e){
      e.preventDefault();
      if(item.classList.contains('gp__vid-item--playing')){resetToCover(item);}
      else{playVideo(item);}
    }
    if(playBtn)playBtn.addEventListener('click',handleActivate);
    if(cover)cover.addEventListener('click',handleActivate);
    video.addEventListener('click',handleActivate);
    video.addEventListener('ended',function(){
      // Hold on the last frame for 3s before returning to the cover image.
      var t=setTimeout(function(){resetToCover(item);},3000);
      endTimers.set(item,t);
    });
  });

  // If the video row scrolls ~80%+ off-screen while something is playing,
  // send everything back to its cover image.
  if('IntersectionObserver' in window){
    var io=new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if(entry.intersectionRatio<0.2){
          items.forEach(function(item){
            if(item.classList.contains('gp__vid-item--playing'))resetToCover(item);
          });
        }
      });
    },{threshold:[0.2]});
    io.observe(vidsGrid);
  }
})();
(function(){
  // Mobile only: scale the product title's font-size so its rendered text
  // width always matches the width of the box below it (review/social-proof
  // box), instead of leaving a gap or overflowing. Desktop is untouched.
  var title=document.querySelector('.gp__title');
  if(!title)return;
  function fitTitle(){
    if(window.innerWidth>900){title.style.fontSize='';return;}
    title.style.fontSize='';
    var container=title.parentElement;
    var containerWidth=container?container.clientWidth:0;
    if(!containerWidth)return;
    var baseSize=parseFloat(getComputedStyle(title).fontSize);
    var clone=title.cloneNode(true);
    clone.style.position='absolute';
    clone.style.visibility='hidden';
    clone.style.whiteSpace='nowrap';
    clone.style.left='-9999px';
    clone.style.top='0';
    clone.style.width='auto';
    clone.style.fontSize=baseSize+'px';
    document.body.appendChild(clone);
    var naturalWidth=clone.scrollWidth;
    document.body.removeChild(clone);
    if(!naturalWidth)return;
    title.style.fontSize=(baseSize*(containerWidth/naturalWidth))+'px';
  }
  fitTitle();
  window.addEventListener('load',fitTitle);
  window.addEventListener('resize',fitTitle);
  if(document.fonts&&document.fonts.ready)document.fonts.ready.then(fitTitle);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gymgrl-results-timeline"] && !Shopify.designMode) return;
  try {
    
(function() {
  var dots = document.querySelectorAll('.grt__node-dot');
  if (!dots.length || !window.IntersectionObserver) return;
  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('grt__node-dot--visible');
        observer.unobserve(entry.target);
      }
    });
  }, { rootMargin: '-45% 0px -45% 0px' });
  dots.forEach(function(dot) { observer.observe(dot); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gymgrl-ugc-strip"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('.gug').forEach(function(section){
    var videos = Array.from(section.querySelectorAll('.gug__video'));
    var btns = Array.from(section.querySelectorAll('.gug__unmute'));

    var observer = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        var video = entry.target;
        if(entry.isIntersecting){
          video.play().catch(function(){});
        } else {
          video.pause();
        }
      });
    }, { threshold: 0.25 });

    videos.forEach(function(video){ observer.observe(video); });

    videos.forEach(function(video){
      var wrap = video.closest('.gug__video-wrap');
      if(!wrap) return;
      function syncPausedState(){ wrap.classList.toggle('is-paused', video.paused); }
      video.addEventListener('play', syncPausedState);
      video.addEventListener('pause', syncPausedState);
      syncPausedState();
    });

    function toggleMute(video){
      var wasMuted = video.muted;
      section.querySelectorAll('.gug__video').forEach(function(v){ v.muted = true; });
      section.querySelectorAll('.gug__unmute').forEach(function(b){
        b.querySelector('.gug__icon-muted').style.display = '';
        b.querySelector('.gug__icon-sound').style.display = 'none';
      });
      if(wasMuted){
        video.muted = false;
        var btn = video.closest('.gug__video-wrap').querySelector('.gug__unmute');
        if(btn){
          btn.querySelector('.gug__icon-muted').style.display = 'none';
          btn.querySelector('.gug__icon-sound').style.display = '';
        }
      }
    }

    btns.forEach(function(btn){
      btn.addEventListener('click', function(){
        var video = btn.closest('.gug__video-wrap').querySelector('.gug__video');
        toggleMute(video);
      });
    });

    videos.forEach(function(video){
      video.addEventListener('click', function(){
        if(window.innerWidth <= 600) return;
        if(video.paused){
          // A direct click is a real user gesture, so play() here succeeds
          // even when the browser's Low Power Mode blocked the earlier
          // automatic autoplay attempt from the IntersectionObserver above.
          video.play().catch(function(){});
          return;
        }
        toggleMute(video);
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
